import React, { useEffect } from "react";
import { IoAlertCircleOutline } from "react-icons/io5";

function Toast({ message, show, onClose }) {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [show, onClose]);

    if (!show) return null;

    return (
        <div className="toast show">
            <span className="toast-icon">
                <IoAlertCircleOutline />
            </span>
            {message}
        </div>
    );
}

export default Toast;
